import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AntragRequest, BackendOberflaecheService, Helper } from '@vhv/tarifrechner-common';
import { ActivatedRoute } from '@angular/router';
import { RateCyberService } from '../rate/rate-cyber.service';

@Injectable({
    providedIn: 'root',
})
export class SendeAntragsdatenCyberService {
    constructor(
        private http: HttpClient,
        private backendOberflaecheService: BackendOberflaecheService,
        private inputRoute: ActivatedRoute,
        private rateCyberService: RateCyberService
    ) {}

    public getAntragRequest(): AntragRequest<CyberFachdaten> {
        const ausgefuellteWerte = this.backendOberflaecheService.getAusgefuellteWerte() as CyberTarifrechnerDaten;

        return new AntragRequest<CyberFachdaten>(
            '', // Erstelldatum wird server-seitig bestimmt
            ausgefuellteWerte.Firmenname,
            ausgefuellteWerte.Email,
            ausgefuellteWerte.Telefon,
            ausgefuellteWerte.Anrede,
            ausgefuellteWerte.Titel,
            ausgefuellteWerte.Vorname,
            ausgefuellteWerte.Nachname,
            {
                strasse: ausgefuellteWerte.Strasse,
                hausnummer: ausgefuellteWerte.Hausnummer,
                postleitzahl: ausgefuellteWerte.PLZ,
                ort: ausgefuellteWerte.Ort,
                land: 'Deutschland',
            },
            ausgefuellteWerte.Geburtsdatum,
            '', // nicht benötigt für Cyber
            {
                iban: ausgefuellteWerte.IBAN,
                bic: ausgefuellteWerte.BIC,
                kontoinhaberAnrede: ausgefuellteWerte.AbwKontoinhaberAnrede,
                kontoinhaberVorname: ausgefuellteWerte.AbwKontoinhaberVorname,
                kontoinhaberNachname: ausgefuellteWerte.AbwKontoinhaberNachname,
                kontoinhaberAnschrift: {
                    strasse: ausgefuellteWerte.AbwKontoinhaberStrasse,
                    hausnummer: ausgefuellteWerte.AbwKontoinhaberHausnummer,
                    postleitzahl: ausgefuellteWerte.AbwKontoinhaberPLZ,
                    ort: ausgefuellteWerte.AbwKontoinhaberOrt,
                    land: 'Deutschland',
                },
            },
            ausgefuellteWerte.Versicherungsbeginn,
            'JAEHRLICH', // immer jährlich für Cyber, wird vom Backend überschrieben
            ausgefuellteWerte.Vermittlernummer,
            this.rateCyberService.getFachdaten(),
        );
    }

    public getDownloadRequest(): { data: AntragRequest<CyberFachdaten> } {
        const cyberAntragRequest = this.getAntragRequest();
        const cyberAntragJsonObject = JSON.parse(JSON.stringify(cyberAntragRequest));

        // Setze Platzhalterwerte ins Pflichtfeld zur Dokumentengenerierung
        cyberAntragJsonObject.fachdaten.downloadZeitstempel = 'n/a';

        return {
            data: cyberAntragJsonObject
        };
    }

}
